import React from 'react';
import { v4 as uuid } from 'uuid';
import { muiChevronDown } from '@ally/metronome-icons';
import styled, { css } from 'styled-components';
import { VisuallyHiddenDiv } from './shared';
import { Icon } from '../../Icon';
const InputWrapper = styled.button(({ theme: { colors, font, space }, $isOpen, $isError }) => css `
    border: none;
    cursor: pointer;
    background-color: ${colors['gray-100']};
    border-radius: 4px 4px 0 0;
    width: 100%;
    font-size: ${font.body.md.size};
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${space.xs};
    height: 45px;
    border-bottom: 1px solid ${colors['blue-800']};
    &:disabled {
      background-color: ${colors['periwinkle-100']};
    }
    &:hover {
      background-color: ${colors['gray-200']};
    }
    &:focus {
      height: ${$isOpen ? '46px' : '45px'};
      border-bottom: ${$isOpen ? '2px' : '1px'} solid ${colors['blue-800']};
    }
    ${$isOpen
    ? css `
          height: 46px;
          border-bottom: 2px solid ${colors['blue-800']};
        `
    : ''}
    ${$isError
    ? css `
          && {
            height: 45px;
            border-bottom: 1px solid ${colors.error};
          }
        `
    : ''}
    ${$isOpen && $isError
    ? css `
          && {
            height: 46px;
            border-bottom: 2px solid ${colors.error};
          }
        `
    : ''}
  `);
const InputWrapperAriaDescribedBy = ({ ariaDescribedBy, id }) => {
    return React.createElement(VisuallyHiddenDiv, { id: id }, ariaDescribedBy);
};
const MultiSelectMenuButton = React.forwardRef(({ label, text, isError, isOpen, isDisabled, setIsOpen, buttonID, errorNotificationID, ariaDescribedBy, checkboxRef, }, ref) => {
    const { current: inputWrapperAriaDescribedByID } = React.useRef(uuid());
    const handleOnClick = () => {
        setIsOpen(open => !open);
        if (!isOpen) {
            // timeout is needed due to css transition when menu opens
            window.setTimeout(() => { var _a; return (_a = checkboxRef.current) === null || _a === void 0 ? void 0 : _a.focus(); }, 0);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(InputWrapper, { onClick: handleOnClick, "$isOpen": isOpen, "$isError": isError, disabled: isDisabled, id: buttonID, "aria-expanded": isOpen ? 'true' : 'false', "aria-label": `${label} select list`, "aria-describedby": `${inputWrapperAriaDescribedByID} ${errorNotificationID}`, "aria-haspopup": "true", ref: ref },
            React.createElement("span", null, text),
            React.createElement(Icon, { icon: muiChevronDown, fill: "blue-800", size: "sm", ariaHidden: true }),
            React.createElement(InputWrapperAriaDescribedBy, { ariaDescribedBy: ariaDescribedBy, id: inputWrapperAriaDescribedByID }))));
});
export { MultiSelectMenuButton };
//# sourceMappingURL=MultiSelectMenuButton.js.map